import { ComponentProps, useMemo } from 'react';
import { Slideshow } from '@carbonify/ui';
import { type Block, default as BlockItem } from 'components/Blocks';
import AuthorBlock from 'components/Blocks/AuthorBlock';

interface SlideshowModuleProps {
  content: Block[];
}

type PersonBlock = ComponentProps<typeof AuthorBlock>;

export default function SlideshowModuleContent({ content }: SlideshowModuleProps) {
  const slides = useMemo(
    () =>
      content.map((block) => ({
        key: block.id,
        header:
          'person' in block && block.person ? (
            <AuthorBlock
              {...(block.person as PersonBlock)}
              cta=""
            />
          ) : (
            (block.title as string)
          ),
        body: <BlockItem {...block} />,
      })),
    [content],
  );

  return <Slideshow slides={slides} />;
}
